var $1486a16b22508ab9$exports = {};
$1486a16b22508ab9$exports = {
    "decrease": (args)=>`${args.fieldLabel}\u{3092}\u{7E2E}\u{5C0F}`,
    "increase": (args)=>`${args.fieldLabel}\u{3092}\u{62E1}\u{5927}`,
    "numberField": `\u{6570}\u{5024}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{30C9}`
};


export {$1486a16b22508ab9$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
